import { NgModule } from '@angular/core';
import { angularProvidersBuilder } from '@harmony/angular';

import { FeedDefaultProvider, FeedProvider } from './feed.provider';
import { GetTeamFeedInteractor } from './domain/interactors/get-team-feed.interactor';
import { FirebaseToken } from '../../app/core/firebase.module';
import { Firestore } from 'firebase/firestore';
import { GetTeamFeedUpdatesInteractor } from './domain/interactors/get-team-feed-updates.interactor';
import { AddFeedItemInteractor } from './domain/interactors/add-feed-item.interactor';
import { RemoveFeedItemsInteractor } from './domain/interactors/remove-feed-items.interactor';
import { UpdateFeedItemsAlbumInteractor } from './domain/interactors/update-feed-items-album.interactor';
import { UpdateFeedItemInteractor } from './domain/interactors/update-feed-item.interactor';
import { StorageProvider } from '../storage/storage.provider';
import { CommonProvider } from '../common/common.provider';

@NgModule({
  providers: angularProvidersBuilder({
    provide: FeedProvider,
    deps: [CommonProvider, FirebaseToken.Firestore, StorageProvider],
    useFactory: (
      commonProvider: CommonProvider,
      firestore: Firestore,
      storageProvider: StorageProvider,
    ) => new FeedDefaultProvider(commonProvider, firestore, storageProvider),
  })
    .add(AddFeedItemInteractor, (p) => p.provideAddFeedItem())
    .add(GetTeamFeedInteractor, (p) => p.provideGetTeamFeed())
    .add(GetTeamFeedUpdatesInteractor, (p) => p.provideGetTeamFeedUpdates())
    .add(RemoveFeedItemsInteractor, (p) => p.provideRemoveFeedItems())
    .add(UpdateFeedItemInteractor, (p) => p.provideUpdateFeedItem())
    .add(UpdateFeedItemsAlbumInteractor, (p) => p.provideUpdateFeedItemsAlbum())
    .build(),
})
export class FeedProviderModule {}
